module.exports = __webpack_public_path__ + "static/media/sql.7afaf2cf.png";